import { useState } from "react";
import { UpsertTemplateModal } from "../UpsertTemplateModal/UpsertTemplateModal";
import type { Mode } from "../UpsertTemplateModal/useUpsertTemplateModal";
import { SaveTemplatePromptModal } from "./SaveTemplatePromptModal";

export const useSaveTemplatePromptModal = ({
  closeEditor,
}: {
  closeEditor: () => void;
}) => {
  const [
    shouldShowSaveEmailAsTemplateModal,
    setShouldShowSaveEmailAsTemplateModal,
  ] = useState(false);
  const [mode, setMode] = useState<Mode | null>(null);

  const handleOpenModal = () => {
    setShouldShowSaveEmailAsTemplateModal(true);
  };

  const handleCloseModal = () => {
    setShouldShowSaveEmailAsTemplateModal(false);
    setMode(null);
    closeEditor();
  };

  const setModeToRenderUpsertTemplateModal = () => {
    setShouldShowSaveEmailAsTemplateModal(false);
    setMode("create_only");
  };

  return {
    modalElement: (
      <>
        {mode ? (
          <UpsertTemplateModal mode={mode} onClose={handleCloseModal} />
        ) : (
          <SaveTemplatePromptModal
            isOpen={shouldShowSaveEmailAsTemplateModal}
            onClose={handleCloseModal}
            handleSaveAsTemplate={setModeToRenderUpsertTemplateModal}
          />
        )}
      </>
    ),
    openModal: handleOpenModal,
  };
};
